import React, { useState, useEffect } from "react";
import Logo from "../../assets/logo.png";
import "./Header.css";
import { Link } from "react-scroll";
import Bars from "../../assets/bars.png";

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpened, setMenuOpened] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const closeMenu = () => setMenuOpened(false);

  return (
    <div className="header" id="header">
      <img src={Logo} alt="" className="logo" />
      {!isMobile ? (
        <ul className="header-menu">
          <li><Link onClick={closeMenu} to="header" spy={true} smooth={true}>Home</Link></li>
          <li><Link onClick={closeMenu} to="programs" spy={true} smooth={true}>Programs</Link></li>
          <li><Link onClick={closeMenu} to="reasons" spy={true} smooth={true}>Why us</Link></li>
          <li><Link onClick={closeMenu} to="plans" spy={true} smooth={true}>Plans</Link></li>
          <li><Link onClick={closeMenu} to="testimonials" spy={true} smooth={true}>Testimonials</Link></li>
          <li><Link onClick={closeMenu} to="contact" spy={true} smooth={true}>Contact us</Link></li>
          <li><Link onClick={closeMenu} to="about" spy={true} smooth={true}>About us</Link></li>
        </ul>
      ) : !menuOpened ? (
        <div className="hamburger" onClick={() => setMenuOpened(true)}>
          <img src={Bars} alt="menu" />
        </div>
      ) : (
        <div className="mobile-menu">
          <span className="close-btn" onClick={closeMenu}>&times;</span>
          <ul className="header-menu">
            <li><Link onClick={closeMenu} to="header" spy={true} smooth={true}>Home</Link></li>
            <li><Link onClick={closeMenu} to="programs" spy={true} smooth={true}>Programs</Link></li>
            <li><Link onClick={closeMenu} to="reasons" spy={true} smooth={true}>Why us</Link></li>
            <li><Link onClick={closeMenu} to="plans" spy={true} smooth={true}>Plans</Link></li>
            <li><Link onClick={closeMenu} to="testimonials" spy={true} smooth={true}>Testimonials</Link></li>
            <li><Link onClick={closeMenu} to="contact" spy={true} smooth={true}>Contact us</Link></li>
            <li><Link onClick={closeMenu} to="about" spy={true} smooth={true}>About us</Link></li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Header;
